import { useCurrentAccount, useCustomQuery } from '@gripp/shared-logic';
import { IconName, NavigationButton } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { NavLinkProps } from '../../dashboard/components/menuLink';

const GET_FRESHDESK_URL = `
  query GetFreshdeskUrl {
    help {
      getFreshdeskUrl {
        url
      }
    }
  }
`;

/**
 * Help menu item that opens Freshdesk support in a new tab
 */
export const HelpMenuItem = (props: NavLinkProps) => {
  const { t } = useTranslation();
  const { account } = useCurrentAccount();
  const { refetch } = useCustomQuery({
    cacheKey: ['getFreshdeskUrl', account?.id],
    query: GET_FRESHDESK_URL,
    options: { enabled: false },
  });

  const onClick = async () => {
    const result = await refetch();
    const url = result.data?.help?.getFreshdeskUrl?.url;
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <NavigationButton
      icon={props.icon as IconName}
      text={t(props.titleKey)}
      active={false}
      showIcon={true}
      showText={true}
      mode="light"
      collapsed={props.collapsed}
      onPress={onClick}
    />
  );
};
